// Used in avenue-eval.component.html and avenue-eval-student-video.component.html

import { Component, OnInit } from "@angular/core";

@Component({
    selector: "no-video-found",
    templateUrl: "./no-video-found.component.html",
    styleUrls: ["./no-video-found.component.scss"],
    standalone: false
})
export class NoVideoFoundComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
